import { CustomSelect, type CustomSelectOption } from "./CustomSelect.tsx";

export interface CustomTimePickerProps {
  value: string; // HH:mm
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  "aria-label"?: string;
  minuteStep?: number;
  options?: CustomSelectOption<string>[];
}

export const SCHEDULE_TIME_OPTIONS: CustomSelectOption<string>[] = Array.from({ length: 48 }, (_, i) => {
  const h = String(Math.floor(i / 2)).padStart(2, "0");
  const m = i % 2 === 0 ? "00" : "30";
  const val = `${h}:${m}`;
  return {
    value: val,
    label: val,
  };
});

export function getScheduleTimeOptions(currentValue?: string, step: number = 30): CustomSelectOption<string>[] {
  const val = String(currentValue ?? "").trim();
  const options = step === 60
    ? Array.from({ length: 24 }, (_, i) => {
        const h = String(i).padStart(2, "0");
        return { value: `${h}:00`, label: `${h}:00` };
      })
    : SCHEDULE_TIME_OPTIONS;

  if (val && !options.some((o) => o.value === val)) {
    return [{ value: val, label: val }, ...options].sort((a, b) => a.value.localeCompare(b.value));
  }
  return options;
}

export function CustomTimePicker({
  value,
  onChange,
  disabled = false,
  className = "",
  "aria-label": ariaLabel = "执行时间",
  minuteStep = 30,
  options,
}: CustomTimePickerProps) {
  const timeOptions = options ?? getScheduleTimeOptions(value, minuteStep === 60 ? 60 : 30);

  return (
    <CustomSelect
      value={value || "09:00"}
      onChange={(val) => onChange(String(val))}
      options={timeOptions}
      disabled={disabled}
      className={`custom-time-select ${className}`.trim()}
      aria-label={ariaLabel}
    />
  );
}
